import type { IFormxRepository } from '../repositories/IFormxRepository.js';
import type { FormxFieldEntity } from '../entities/FormxEntity.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxFieldsUseCase({ formxRepository }: Deps) {
  return async function listFormxFields(formId: string): Promise<FormxFieldEntity[]> {
    return formxRepository.listFields(formId);
  };
}
